module.exports = __webpack_public_path__ + "img/Nashville-02.8f0c2163.jpg";